import { render, staticRenderFns } from "./dealimageSlider.vue?vue&type=template&id=c49d477a&"
import script from "./dealimageSlider.vue?vue&type=script&lang=js&"
export * from "./dealimageSlider.vue?vue&type=script&lang=js&"
import style0 from "./dealimageSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports